// extracted by mini-css-extract-plugin
export default {"container":"builderTypePage_container__bBAyD"};